'use client';

import Icon from '@/components/ui/AppIcon';

const WhatsAppIntegration = () => {
  const phoneNumber = '07445270141';
  const whatsappLink = `https://wa.me/44${phoneNumber?.slice(1)}`;

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-3d overflow-hidden border-2 border-green-200">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Left Side - Content */}
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl mb-6">
                <Icon name="DevicePhoneMobileIcon" size={32} className="text-white" />
              </div>
              
              <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground mb-4">
                Chat with Us on WhatsApp
              </h2>
              
              <p className="text-lg text-muted-foreground mb-6">
                Get instant responses to your travel questions. Our team is ready to help you plan your perfect journey.
              </p>

              <div className="space-y-3 mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon name="CheckIcon" size={16} className="text-green-600" />
                  </div>
                  <span className="text-foreground font-medium">Instant message delivery</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon name="CheckIcon" size={16} className="text-green-600" />
                  </div>
                  <span className="text-foreground font-medium">Share photos and documents easily</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon name="CheckIcon" size={16} className="text-green-600" />
                  </div>
                  <span className="text-foreground font-medium">Available 24/7 for your convenience</span>
                </div>
              </div>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white font-heading font-black rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 active:scale-95"
              >
                <Icon name="DevicePhoneMobileIcon" size={24} />
                <span>Start WhatsApp Chat</span>
                <Icon name="ArrowRightIcon" size={20} />
              </a>

              <p className="text-sm text-muted-foreground mt-4">
                Phone: <span className="font-bold text-foreground">{phoneNumber}</span>
              </p>
            </div>

            {/* Right Side - Visual */}
            <div className="bg-gradient-to-br from-green-500 via-emerald-500 to-teal-500 p-8 lg:p-12 flex items-center justify-center">
              <div className="relative">
                {/* WhatsApp Icon Illustration */}
                <div className="w-48 h-48 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <div className="w-36 h-36 bg-white rounded-full flex items-center justify-center shadow-2xl">
                    <svg className="w-24 h-24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 13.54 2.39 15 3.08 16.28L2 22L7.85 20.94C9.09 21.57 10.5 21.93 12 21.93C17.52 21.93 22 17.45 22 11.93C22 6.41 17.52 2 12 2Z" fill="#25D366"/>
                      <path d="M17.5 14.5C17.25 14.38 16.06 13.79 15.84 13.71C15.62 13.63 15.46 13.59 15.3 13.84C15.14 14.09 14.67 14.64 14.53 14.8C14.39 14.96 14.25 14.98 14 14.86C13.75 14.74 12.94 14.48 11.97 13.62C11.22 12.95 10.72 12.13 10.58 11.88C10.44 11.63 10.56 11.5 10.68 11.38C10.79 11.27 10.93 11.09 11.05 10.95C11.17 10.81 11.21 10.71 11.29 10.55C11.37 10.39 11.33 10.25 11.27 10.13C11.21 10.01 10.72 8.82 10.52 8.32C10.33 7.83 10.13 7.89 9.99 7.88H9.58C9.42 7.88 9.16 7.94 8.94 8.19C8.72 8.44 8.09 9.03 8.09 10.22C8.09 11.41 8.96 12.56 9.08 12.72C9.2 12.88 10.72 15.27 13.05 16.31C13.62 16.57 14.06 16.72 14.41 16.83C14.98 17.01 15.5 16.98 15.91 16.92C16.36 16.85 17.3 16.33 17.5 15.76C17.7 15.19 17.7 14.7 17.64 14.6C17.58 14.5 17.42 14.44 17.17 14.32L17.5 14.5Z" fill="white"/>
                    </svg>
                  </div>
                </div>
                
                {/* Decorative Elements */}
                <div className="absolute -top-4 -right-4 w-16 h-16 bg-white/30 rounded-full animate-pulse" />
                <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '1s' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppIntegration;